export function cn(...classNames) {
  if (!Array.isArray(classNames)) return "";
  return classNames.filter(Boolean).join(" ");
}
